export function blurActiveElement(event: KeyboardEvent, stopPropagation = true): void {
  if (stopPropagation) {
    event.preventDefault();
    event.stopPropagation();
  }
  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
}
